import ptBrTranslation from "./pt-br";
import enUsTranslation from "./en-us";

export default {
  "pt-BR": ptBrTranslation,
  "en-US": enUsTranslation,
};
